import React from "react";

type TInfoRowProps = {
    text?: React.ReactNode;
    style?: React.CSSProperties;
};

const InfoRow = (props: TInfoRowProps) => {
    const classes = props.text ? ["active"] : ["inactive"];
    classes.push("info");

    return (
        <div className={classes.join(" ")} style={props.style}>
            {props.text}
        </div>
    );
};

export default InfoRow;
